import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SessionChecker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const excludedRoutes = [
      "/sign-up",
      "/log-in",
      "/forgot-password",
      "/reset-password",
    ];

    if (excludedRoutes.includes(location.pathname)) return;
  }, [location.pathname]);

  return null;
};

export default SessionChecker;
